import React from 'react';
import { Link } from 'react-router-dom';

const Paywall = () => {
    return (
        <div className="text-center p-5 bg-light rounded shadow-sm border">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ width: '60px', height: '60px', color: '#0d6efd' }} className="mb-3">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
            </svg>
            <h2 className="fw-bold">Exclusive Content</h2>
            <p className="lead text-muted mb-4">
                To access this category and view our full directory of professionals, please subscribe.
            </p>
            <Link to="/signup" className="btn btn-primary btn-lg">
                Become a Member
            </Link>
        </div>
    );
};

export default Paywall;
